import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { get, isEmpty } from 'lodash';
import {
  isGoldUpdated,
  update,
} from '../LeisureTravelForm/Components/TabContent/redux/ReviewTabActions';
import { closeModal } from '../../../../common/components/Modal/ModalRedux';
import { Button, Modal } from '../../../../common/components';
import displayCurrency from '../../../../helpers/displayCurrency';
import PolicyUpgradesBox from './components/PolicyUpgradesBox';
import getIncludedResource from '../../../../helpers/getIncludedResource';
import UpgradeToGoldBox from './components/UpgradeToGoldBox/UpgradeToGoldBox';

const FORM_NAME = 'upgradeToGold';

class PolicyUpgrades extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isGoldUpgraded: null,
      scheme: [],
    };
  }

  componentDidMount() {
    // redux-form validation according to the tab
    const { dispatch } = this.props;

    // boltOns initial value
    dispatch(isGoldUpdated(false));
    this.setState({
      isGoldUpgraded: false,
    });

    const storeGoldScheme = this.props.updateBolton.updateBolton[0];
    // Store the value only if the scheme is not already updated
    if (
      this.state.scheme.length > 0 &&
      this.state.scheme[0] !== this.props.updateBolton.updateBolton[0]
    ) {
      if (this.state.scheme.isLength === 0 && this.props.updateBolton.isGoldUpdated) {
        this.setState({
          scheme: storeGoldScheme,
        });
      }
    }
  }

  handleClose = () => {
    const { dispatch, onGoToReview } = this.props;
    dispatch(closeModal(FORM_NAME));
    onGoToReview();
  };

  componentWillReceiveProps(nextProps) {
    const { product, dispatch } = this.props;
    const noGoldScheme = [];
    let isGoldUpdatedVar = nextProps.updateBolton.isGoldUpdated;

    noGoldScheme.push(get(product, 'premiumIndication.meta.scheme.id', 0));

    // sync the Store with the local state
    if (this.state.isGoldUpgraded !== isGoldUpdatedVar) {
      this.setState({
        isGoldUpgraded: isGoldUpdatedVar,
      });
    }

    if (!isGoldUpdatedVar) {
      // Persist the old Scheme in the redux-store for downgrade purposes
      dispatch(update(noGoldScheme));
    }
  }

  handleUpgradeToGold = (isSelected, scheme) => {
    const { dispatch, handleSchemeSelect } = this.props;

    this.setState(
      () => ({
        isGoldUpgraded: isSelected,
      }),
      () => {
        dispatch(isGoldUpdated(this.state.isGoldUpgraded));
        // Upgrade
        // TODO delete options
        if (this.state.isGoldUpgraded) {
          handleSchemeSelect(scheme, true);
        } else {
          // Downgrade with the old scheme
          handleSchemeSelect(this.props.updateBolton.updateBolton[0], true);
        }
      },
    );
    // dispatch(closeModal(FORM_NAME))
  };

  handleOnHide() {
    const { dispatch, change, formValues } = this.props;
    const metaPolicyUpgrade = 'data.attributes.metadata.upgrade';
    dispatch(change('data.attributes.metadata.options.travel_dispute', false));
    dispatch(change('data.attributes.metadata.options.end_supplier_failure', false));
    dispatch(change('data.attributes.metadata.options.smart_luggage', false));
    dispatch(isGoldUpdated(false));
    if (isEmpty(get(formValues, `${metaPolicyUpgrade}`, []))) {
      dispatch(change(`${metaPolicyUpgrade}`, 'Gold'));
    }
  }

  handleOnShow() {
    const { formValues, dispatch, change } = this.props;
    const metaPolicyUpgrade = 'data.attributes.metadata.upgrade';
    // Retrieving to cover cases when the singleCalculation() is not invoked e.g.: edit quote
    this.props.retrieveUpgrade();

    if (isEmpty(get(formValues, `${metaPolicyUpgrade}`, []))) {
      dispatch(change(`${metaPolicyUpgrade}`, 'Gold'));
    }
  }

  render() {
    const { product, submitting, label } = this.props;
    const boltOns = get(product, 'premiumIndication.meta.information.bolt_ons');
    const availableOptions = get(
      product,
      'premiumIndication.meta.information.available_options',
    );

    const boltOnsToAdd =
      (boltOns &&
        availableOptions &&
        Object.keys(boltOns).reduce((carry, boltOnKey) => {
          const boltonOption = availableOptions[boltOnKey];
          if (boltonOption) {
            carry[boltOnKey] = boltOns[boltOnKey];
          }
          return carry;
        }, {})) ||
      {};

    const { amount, scheme } = get(
      product,
      'premiumIndication.meta.information.upgrade',
      {},
    );

    const goldAmountDiff = amount ? amount.difference : null;
    const goldAmountTotal = amount ? amount.total : null;

    const schemeObject = getIncludedResource(
      scheme,
      product.schemes,
      false,
      'products/schemes',
    );
    const benefits = get(product, 'premiumIndication.meta.benefits', []);
    const goldBenefits = get(
      product,
      'premiumIndication.meta.information.upgrade.benefits',
      [],
    );

    const totalToPay =
      !this.state.isGoldUpgraded ||
      get(schemeObject, 'data.attributes.cover_level') === 'Gold'
        ? get(product, 'premiumIndication.meta.premium.gross', 0)
        : goldAmountTotal;

    const title = label || 'Policy Upgrades';
    const submitButton = (
      <Button
        type="submit"
        bsStyle="primary"
        className="settings-button"
        disabled={product.isCalculating}
        isLoading={submitting}
        label="continue"
        handleClick={this.handleClose}
      />
    );

    return (
      <div style={{ clear: 'both' }}>
        <Modal
          name={FORM_NAME}
          title={title}
          close
          footer={submitButton}
          onHide={this.handleOnHide.bind(this)}
          onShow={this.handleOnShow.bind(this)}
        >
          <div>
            <div className="policy-upgrades-box">
              <div className="flex-container-review">
                <Field
                  name="data.attributes.metadata.policy_upgrade"
                  component={PolicyUpgradesBox}
                  isGold={this.state.isGoldUpgraded}
                  boltOns={boltOnsToAdd || {}}
                  product={product}
                  options={availableOptions}
                />
              </div>
              <div className="quote-divider" />

              <div className="gold-promotion">
                <UpgradeToGoldBox
                  isGoldUpgraded={this.state.isGoldUpgraded}
                  hasGoldUpgrade={!!goldAmountTotal}
                  scheme={schemeObject}
                  goldScheme={scheme}
                  benefits={benefits}
                  goldBenefits={goldBenefits}
                  hasBoltons={!!boltOnsToAdd}
                  upgradeDiff={goldAmountDiff}
                  boltOnList={boltOnsToAdd ? Object.keys(boltOnsToAdd) : []}
                  onUpgradeToGold={this.handleUpgradeToGold}
                />
              </div>
              <div className="quote-divider" />
              <p className="policy-upgrade-modal-bottom">
                If you do not wish to upgrade your cover, select continue to proceed to
                payment, or close to return to your quotes.
              </p>

              <div className="upsell-premium">
                <p> Total Payable <strong>{displayCurrency(totalToPay)}</strong> inc IPT </p>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
export default connect()(PolicyUpgrades);
